import { Translate } from '@chipinside/translate'
import { Button, Tooltip } from '@mui/material'

import { Drawer } from '#/components/Drawer'
import { HelpContent } from '#/components/HelpPages/content'
import { usePage } from '#/components/HelpPages/utils'
import { Icon } from '#/components/Icon'
import { useHelpPages } from '#/store/ducks/auth'

export function HelpPages() {
  const page = usePage()
  const help_pages = useHelpPages() as string[]

  if (!page || !help_pages?.includes(page?.id)) return null

  const handleOpen = () => {
    Drawer.open({
      content: <HelpContent page={page} />,
    })
  }

  return (
    <Tooltip title={Translate({ messageKey: 'show_help' })}>
      <Button
        variant="text"
        color="warning"
        startIcon={<Icon name="help" size={18} />}
        onClick={() => handleOpen()}
        sx={{
          lineHeight: 'normal',
          minHeight: 'unset',
          px: 2,
        }}
      >
        {Translate({ messageKey: 'more' })}
      </Button>
    </Tooltip>
  )
}
